import { Button, Result } from 'antd';

import React from 'react';

const Page404: React.FC = () => {
    return (
        <Result
            status="404"
            title="404"
            subTitle="Sorry, this service is not accessable right now."
            extra={
                <Button type="primary" onClick={() => console.log('Hello go back button')}>
                    Back Home
                </Button>
            }
        />
    );
};

export default Page404;
